import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Images/hcgroup.jpg'


const _hoisted_1 = ["src"]

import { computed, onMounted, ref } from 'vue';
import axios from 'axios';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTMAPS from '@/constants/maps';
import CONSTANTIMGS from '@/constants/images';
import { APIS_KPI, APIS_MAP, APIS_DRIVE } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 ************ LEAFLET ***********
 *******************************/
import { LMap, LTileLayer, LMarker, LIcon, LControlZoom, LControl } from "@vue-leaflet/vue-leaflet";
import { PointExpression } from 'leaflet';
import "/public/leaflet/leaflet.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'InicioView',
  setup(__props) {

const zoomMap = computed( () => CONSTMAPS.zoom.value);
const centerMap = ref<PointExpression>([CONSTMAPS.latitud.value,CONSTMAPS.longitud.value])
const finalURL = ref('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}')


const finalPositions = ref<any>({})

async function getAllPosition() {
    await axios.get(APIS_DRIVE.value.getRajantGPS, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then(async (response) => {
        response.data.forEach((item:any) => {

            if(!finalPositions.value[item.ip]) {
                finalPositions.value[item.ip] = {}
            }

            finalPositions.value[item.ip].fecha = item.fecha;
            finalPositions.value[item.ip].position = [item.latitud, item.longitud];
        })
    })
}


const finalItems = ref<any>([])


async function  getAllLatencyLastMinute() {
    await axios.get(APIS_KPI.value.getAllLatency, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) => {
        const items = response.data;
        items.forEach((item:any) => {
            if(item.tipo.toUpperCase() === 'PERFORADORA'){
                const position = finalPositions.value[item.ip]?.position??null; 

              finalItems.value.push({
                name: item.name,
                ip: item.ip,
                position,
                tipo: item.tipo,
                status: 'ok'
              })
            }
        })
        console.log('finalItems', finalItems.value);
    })
}

onMounted(async() => {
    await getAllPosition()
    await getAllLatencyLastMinute()
})


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "pa-6",
    width: "100%",
    height: "90vh",
    color: "transparent"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(LMap), {
        class: "mapClassBorder",
        zoom: zoomMap.value,
        center: centerMap.value,
        options: { zoomControl: false}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LControlZoom), { position: 'topright' }),
          _createVNode(_unref(LTileLayer), { url: finalURL.value }, null, 8, ["url"]),
          _createVNode(_unref(LControl), { position: "topleft" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                color: "transparent",
                width: "100",
                height: "100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, { src: _imports_0 })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(LControl), { position: "bottomleft" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("span", { class: "mapInnerTittle" }, "SmartLink RAOS")
              ], -1),
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "mapInnerSubTittle" }, "Remote & Autonomous Operation System")
              ], -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalItems.value, (m, index) => {
            return (_openBlock(), _createBlock(_unref(LMarker), {
              key: index,
              "lat-lng": m.position??[0,0]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LIcon), {
                  iconSize: [40, 60],
                  iconAnchor: [35,30]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      color: "transparent",
                      width: 70,
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          height: '70',
                          src: _unref(CONSTANTIMGS).IMAGES.perforadora
                        }, null, 8, _hoisted_1),
                        _createVNode(_component_v_sheet, {
                          class: _normalizeClass('classnameIconRAOS'),
                          color: "bgTopology"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h5", null, _toDisplayString(m.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["lat-lng"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["zoom", "center"])
    ]),
    _: 1
  }))
}
}

})